import Banner from "../components/Banner";
import { FAQ, FAQList, FAQItem } from "../components/FAQ";
import RegisterCallout from "../components/RegisterCallout";
import { Link } from "react-router-dom";

export default function PageFAQ() {
  return (
    <>
      <Banner
        leftImage="img/bg-banner-round-gradient.webp"
        className="bg-white-after"
      >
        <div className="col-12 mb-3">
          <div className="display-1 color-white">
            Frequently Asked Questions
          </div>
        </div>
        <div className="col-12 col-md-9 col-lg-8 col-xl-7 mb-2">
          <p className="color-white mb-0">
            Please don&apos;t hesitate to{" "}
            <a className=" color-white" href="mailto:fincomp@balancedcomp.com">
              email us
            </a>{" "}
            with any questions. A member of our team will reach out to you
            within 48 hours.
          </p>
        </div>
      </Banner>

      <FAQ className="bg-white">
        <FAQList>
          <FAQItem question="Who should attend this event?">
            <p>
              We encourage all banking and credit union professionals, from CEOs
              to HR Generalists, to attend this comprehensive, industry-tailored
              event. Whether attending alone or with your team, FinComp is an
              invaluable experience for financial leaders looking to stay
              up-to-date on the latest trends in finance, salary administration,
              and workforce planning/management.
            </p>
          </FAQItem>

          <FAQItem question="Why should I attend this event?">
            <p>
              FinComp is an excellent opportunity to learn about the latest
              industry trends and developments affecting HR professionals in the
              financial industry. From keynote speakers to breakout sessions and
              interactive workshops, FinComp offers a variety of opportunities
              to gain a comprehensive understanding of the latest market trends,
              best practices, emerging technologies, new market research, and
              benchmark data.
            </p>
            <ul>
              <li>
                <strong>Network with peers and industry leaders:</strong>{" "}
                Conferences bring together professionals from across your
                industry, providing a unique opportunity to meet and network
                with peers and industry leaders. You can connect with financial
                market experts, partners, mentors, and colleagues who can share
                best practices and help you grow your career and/or business
                contribution.
              </li>
              <li>
                <strong>Gain new insights and transferable skills:</strong>{" "}
                FinComp offers a range of sessions and workshops to help you
                develop new knowledge and skills. You&apos;ll learn about comp
                strategy, leadership, compensation law, and more. You can also
                leverage direct face-to-face opportunities with industry leaders
                to gain insight into specific challenges you might currently be
                facing.
              </li>
            </ul>
          </FAQItem>

          <FAQItem question="How do I register for FinComp '27?">
            <p>
              All conference attendees, including those who plan to attend in
              groups, must register individually using the{" "}
              <Link to="/Registration">registration form</Link>.
            </p>
            <p>
              The Post-Conference Workshop is an add-on event scheduled for the
              last day of the conference. To reserve your spot for both events
              (and fully maximize your time and value at FinComp), make sure to
              check both boxes during registration.
            </p>

            <div className="container">
              <div className="row justify-content-center">
                <div className="col-12 col-lg-8 py-5">
                  <img
                    className="img-fluid"
                    src="./img/faq-pass-selection.webp"
                    alt="Pass Selection"
                  />
                </div>
              </div>
            </div>
          </FAQItem>

          <FAQItem question="How can I make hotel reservations and book my room? Where can I find information about the hotel?">
            <p>
              Book your room before Friday, May 14, 2027, to access
              BalancedComp&apos;s discounted hotel group rate of $319 +
              taxes/fees per night for this event! This FinComp-exclusive rate
              will automatically apply to your reservation using the{" "}
              <a
                target="_blank"
                href="https://be.synxis.com/?adult=1&arrive=2025-09-07&chain=11910&child=0&currency=USD&depart=2025-09-10&group=7901519&hotel=12323&level=hotel&locale=en-US&productcurrency=USD&rooms=1"
              >
                Book your room
              </a>{" "}
              link.
            </p>
            <p>
              You will be required to provide a one-night guestroom plus tax
              deposit, and major credit cards are acceptable.
            </p>
            <p>
              Detailed, step-by-step instructions for how to make your hotel
              reservations can be found{" "}
              <a
                target="_blank"
                href="https://scribehow.com/shared/FinComp_2025_Instructions_for_booking_a_hotel_room_at_Estancia_La_Jolla_Hotel_and_Spa__YF7_QEhUQ9WcdFN7J33Ouw?referrer=workspace"
              >
                here
              </a>
              .
            </p>
            <p>
              You can find detailed information about the award-winning Omni La
              Costa Resort &amp; Spa on the{" "}
              <Link to="/Hotel">FinComp Hotel page</Link> or by visiting the{" "}
              <a
                href="https://www.estancialajolla.com/"
                target="_blank"
                rel="noreferrer"
              >
                resort&apos;s website
              </a>
              .
            </p>
            <p>
              You can also call the Omni La Costa Resort &amp; Spa directly at
              1-800-THE-OMNI. Please refer to the group and conference names -
              BalancedComp&apos;s FinComp &apos;27 conference.
            </p>
            <p>
              Looking to extend your stay? The discounted group rate is valid
              for check-in and check-out dates between June 3-12, based on the
              hotel&apos;s availability.
            </p>
            <p>
              Say Goodbye to Hunger! For each FinComp &apos;27 attendee
              reservation, the Omni La Costa Resort &amp; Spa will contribute
              one meal to the local Carlsbad community! Visit{" "}
              <a
                href="https://www.omnihotels.com/SGTHGROUP"
                target="_blank"
                rel="noreferrer"
              >
                Omnihotels.com/SGTHGROUP
              </a>{" "}
              to learn more.
            </p>
          </FAQItem>

          <FAQItem question="Can I bring additional colleagues to FinComp '27?">
            <p>
              The more, the merrier! Attendees are encouraged to experience our
              FinComp conferences individually or as a team. We offer special
              group discounted pricing for those who wish to attend together
              from the same company.
            </p>
            <p>
              Once the first person from your organization completes their
              registration, they&apos;ll receive an automated confirmation email
              that includes a custom group pricing discount code (a total of
              $700 in savings during Early-Bird pricing). Make sure every other
              person in your group who registers enters that code upon
              completing their registration.
            </p>

            <div className="container">
              <div className="row justify-content-center">
                <div className="col-12 col-lg-8 py-5">
                  <img
                    className="img-fluid"
                    src="./img/faq-coupon-code.webp"
                    alt="Coupon Code"
                  />
                </div>
              </div>
            </div>

            <p>
              All registrants must submit their own individual registration
              form.
            </p>
          </FAQItem>

          <FAQItem question="How can I cancel or modify my hotel reservation?">
            <p>
              To cancel or modify your hotel reservation, please contact the
              Omni La Costa Resort &amp; Spa at{" "}
              <a href="tel:800-497-2175">800-497-2175</a>. Any guaranteed
              reservation canceled less than 72 hours prior to the scheduled
              arrival date will be subject to the forfeiture of the one
              night&apos;s room and tax deposit. Cancellations received before
              May 14th will incur a $250 processing fee. Cancellations received
              after May 14th and registrants who fail to provide a written
              cancellation notice within this timeframe will be responsible for
              forfeiting the full registration fee. BalancedComp assumes no
              liability for any nonrefundable travel, hotel, or other related
              expenses incurred by registrants.
            </p>
          </FAQItem>

          <FAQItem question="Before planning my travel itinerary, when should I plan to arrive and depart from the resort for FinComp '27?">
            <p>
              You can check in at the FinComp &apos;27 registration desk between
              3:00 p.m. and 7:00 p.m. on Sunday, June 6th, at the Omni La Costa
              Resort &amp; Spa&apos;s Poinsettia Foyer. If you are participating
              in the post-conference workshop on Wednesday, June 9th, it will
              conclude at 3:00 p.m. Otherwise, the conference will conclude by
              12:00 p.m. (noon) on Wednesday, June 9th.
            </p>
          </FAQItem>

          <FAQItem question="Is there any shuttle transportation provided between the airport and the resort?">
            <p>
              Attendees are responsible for their own transportation between the
              airport and the resort. Uber, Lyft, taxis, and rental cars are
              available at the San Diego International Airport.
            </p>
            <p>
              The resort is located 30 miles from the San Diego International
              Airport. Driving to or from the resort typically takes
              approximately 45 minutes, depending on traffic.
            </p>
          </FAQItem>

          <FAQItem question="Is FinComp Accredited?">
            <p>
              Yes! FinComp is a fully SHRM &amp; HRCI-accredited event. More
              details coming soon.
            </p>
          </FAQItem>

          <FAQItem question="How do I become a sponsor?">
            <p>
              Learn more on the{" "}
              <Link to="/Sponsors">Sponsorship Opportunities</Link> page. If
              you&apos;d like to become a sponsor, you can apply{" "}
              <Link to="/SponsorForm">here</Link>. The number of sponsorships is
              limited - sign up today!
            </p>
          </FAQItem>

          <FAQItem question="What should I bring to this conference?">
            <p>
              Attendees will be provided with pens and notebooks containing the
              conference agenda. Laptops are not required, but are encouraged
              for notes. Digital copies of speaker slide decks will be
              distributed to all event registrants following the conference.
            </p>
          </FAQItem>

          <FAQItem question="What is the recommended dress attire?">
            <p>
              We love a good loungewear set as much as everyone else, but
              business casual attire is recommended for all conference sessions
              and events. Conference rooms can be chilly - we advise wearing
              layers and comfortable shoes!
            </p>
            <p>
              On Monday evening, June 7th, there will be an outdoor cocktail and
              networking mixer on the Valley Promenade from 5:15 - 7:00 p.m.
              Business casual attire is recommended.
            </p>
            <p>
              For returning FinComp attendees, make sure to bring your FinComp
              &apos;25 commemorative lanyard pin and wear it proudly.
            </p>
          </FAQItem>

          <FAQItem question="Any other questions?">
            <p>
              Feel free to email your questions to{" "}
              <a href="mailto:fincomp@balancedcomp.com">
                fincomp@balancedcomp.com
              </a>{" "}
              or BalancedComp&apos;s event manager, Laurie Touchberry, at{" "}
              <a href="mailto:LTT92688@gmail.com">LTT92688@gmail.com</a> or{" "}
              <a href="tel:949-266-4480">949-266-4480</a>.
            </p>
          </FAQItem>
        </FAQList>
      </FAQ>
      <RegisterCallout />
    </>
  );
}
